// // src/components/EditUserModal.js
// import { useState } from "react";

// const EditUserModal = ({ user, preferences, onClose, onSave }) => {
//   const [formData, setFormData] = useState({
//     age: user.age,
//     customer_id: user.customer_id,
//     email: user.email || "",
//     first_name: preferences.first_name || "",
//     gender: preferences.gender || "",
//     ethnicity: preferences.ethnicity || "",
//     customer_persona: preferences.customer_persona || "",
//     promotion_propensity: preferences.promotion_propensity || "",
//     clothing_size: preferences.clothing_size || "",
//     footwear_size: preferences.footwear_size || "",
//     color_preference: preferences.color_preference || "",
//     color_tone_preference: preferences.color_tone_preference || "",
//     apparel_preference: preferences.apparel_preference || "",
//     graphical_appearance_preference:
//       preferences.graphical_appearance_preference || "",
//     fabric_preference: preferences.fabric_preference || "",
//     fit_preference: preferences.fit_preference || "",
//     clothing_budget_preference: preferences.clothing_budget_preference || "",
//     accessory_preference: preferences.accessory_preference || "",
//     accessory_budget_preference: preferences.accessory_budget_preference || "",
//   });
// console.log(user);
//   const [isSaving, setIsSaving] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleNumberChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value === "" ? "" : parseFloat(value),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSaving(true);
//     try {
//       await onSave(formData);
//       onClose();
//     } catch (error) {
//       alert("Failed to save: " + error.message);
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//         <div className="p-6 border-b flex justify-between items-center">
//           <h2 className="text-xl font-semibold">
//             Edit User: {user.first_name} {user.last_name}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700 text-2xl"
//             aria-label="Close"
//           >
//             &times;
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-5">
//           {/* Email */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email *
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//               required
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               age
//             </label>
//             <input
//               type="number"
//               name="age"
//               value={formData.age}
//               onChange={handleNumberChange}
//               step="1"
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* First Name */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               First Name
//             </label>
//             <input
//               type="text"
//               name="first_name"
//               value={formData.first_name}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Gender */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Gender
//             </label>
//             <input
//               type="text"
//               name="gender"
//               value={formData.gender}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Ethnicity */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Ethnicity
//             </label>
//             <input
//               type="text"
//               name="ethnicity"
//               value={formData.ethnicity}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Customer Persona */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Customer Persona
//             </label>
//             <input
//               type="text"
//               name="customer_persona"
//               value={formData.customer_persona || ""}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Promotion Propensity */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Promotion Propensity
//             </label>
//             <select
//               name="promotion_propensity"
//               value={formData.promotion_propensity}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select</option>
//               <option value="low">Low</option>
//               <option value="medium">Medium</option>
//               <option value="high">High</option>
//             </select>
//           </div>

//           {/* Clothing Size */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Clothing Size
//             </label>
//             <input
//               type="text"
//               name="clothing_size"
//               value={formData.clothing_size}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Footwear Size */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Footwear Size
//             </label>
//             <input
//               type="number"
//               name="footwear_size"
//               value={formData.footwear_size}
//               onChange={handleNumberChange}
//               step="0.5"
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Color Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Color Preference
//             </label>
//             <input
//               type="text"
//               name="color_preference"
//               value={formData.color_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Color Tone Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Color Tone Preference
//             </label>
//             <select
//               name="color_tone_preference"
//               value={formData.color_tone_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select</option>
//               <option value="light">Light</option>
//               <option value="medium">Medium</option>
//               <option value="dark">Dark</option>
//             </select>
//           </div>

//           {/* Apparel Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Apparel Preference
//             </label>
//             <input
//               type="text"
//               name="apparel_preference"
//               value={formData.apparel_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Graphical Appearance */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Graphical Appearance Preference
//             </label>
//             <input
//               type="text"
//               name="graphical_appearance_preference"
//               value={formData.graphical_appearance_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Fabric Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Fabric Preference
//             </label>
//             <input
//               type="text"
//               name="fabric_preference"
//               value={formData.fabric_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Fit Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Fit Preference
//             </label>
//             <input
//               type="text"
//               name="fit_preference"
//               value={formData.fit_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Clothing Budget */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Clothing Budget Preference
//             </label>
//             <select
//               name="clothing_budget_preference"
//               value={formData.clothing_budget_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select</option>
//               <option value="budget">Budget</option>
//               <option value="premium">Premium</option>
//             </select>
//           </div>

//           {/* Accessory Preference */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Accessory Preference
//             </label>
//             <input
//               type="text"
//               name="accessory_preference"
//               value={formData.accessory_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             />
//           </div>

//           {/* Accessory Budget */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Accessory Budget Preference
//             </label>
//             <select
//               name="accessory_budget_preference"
//               value={formData.accessory_budget_preference}
//               onChange={handleChange}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md"
//             >
//               <option value="">Select</option>
//               <option value="budget">Budget</option>
//               <option value="premium">Premium</option>
//             </select>
//           </div>

//           <div className="flex justify-end gap-3 pt-4">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={isSaving}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-70"
//             >
//               {isSaving ? "Saving..." : "Save Changes"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditUserModal;
// src/components/EditUserModal.js
import { useState } from "react";

const EditUserModal = ({ user, preferences, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    age: user.age,
    customer_id: user.customer_id,
    email: user.email || "",
    first_name: preferences.first_name || "",
    gender: preferences.gender || "",
    ethnicity: preferences.ethnicity || "",
    customer_persona: preferences.customer_persona || "",
    promotion_propensity: preferences.promotion_propensity || "",
    clothing_size: preferences.clothing_size || "",
    footwear_size: preferences.footwear_size || "",
    color_preference: preferences.color_preference || "",
    color_tone_preference: preferences.color_tone_preference || "",
    apparel_preference: preferences.apparel_preference || "",
    graphical_appearance_preference:
      preferences.graphical_appearance_preference || "",
    fabric_preference: preferences.fabric_preference || "",
    fit_preference: preferences.fit_preference || "",
    clothing_budget_preference: preferences.clothing_budget_preference || "",
    accessory_preference: preferences.accessory_preference || "",
    accessory_budget_preference: preferences.accessory_budget_preference || "",
    // ✅ New fields from user (not preferences)
    address: user.address || "",
    address_tag: user.address_tag || "",
    payment_detail: user.payment_detail || "",
  });

  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? "" : parseFloat(value),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await onSave(formData);
      onClose();
    } catch (error) {
      alert("Failed to save: " + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold">
            Edit User: {user.first_name} {user.last_name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          {/* === Existing Fields === */}
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Age
            </label>
            <input
              type="number"
              name="age"
              value={formData.age}
              onChange={handleNumberChange}
              step="1"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* First Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name
            </label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Gender */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Gender
            </label>
            <input
              type="text"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Ethnicity */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Ethnicity
            </label>
            <input
              type="text"
              name="ethnicity"
              value={formData.ethnicity}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Customer Persona */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Persona
            </label>
            <input
              type="text"
              name="customer_persona"
              value={formData.customer_persona || ""}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Promotion Propensity */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Promotion Propensity
            </label>
            <select
              name="promotion_propensity"
              value={formData.promotion_propensity}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>

          {/* Clothing Size */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Clothing Size
            </label>
            <input
              type="text"
              name="clothing_size"
              value={formData.clothing_size}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Footwear Size */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Footwear Size
            </label>
            <input
              type="number"
              name="footwear_size"
              value={formData.footwear_size}
              onChange={handleNumberChange}
              step="0.5"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Color Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Color Preference
            </label>
            <input
              type="text"
              name="color_preference"
              value={formData.color_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Color Tone Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Color Tone Preference
            </label>
            <select
              name="color_tone_preference"
              value={formData.color_tone_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select</option>
              <option value="light">Light</option>
              <option value="medium">Medium</option>
              <option value="dark">Dark</option>
            </select>
          </div>

          {/* Apparel Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Apparel Preference
            </label>
            <input
              type="text"
              name="apparel_preference"
              value={formData.apparel_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Graphical Appearance */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Graphical Appearance Preference
            </label>
            <input
              type="text"
              name="graphical_appearance_preference"
              value={formData.graphical_appearance_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Fabric Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fabric Preference
            </label>
            <input
              type="text"
              name="fabric_preference"
              value={formData.fabric_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Fit Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fit Preference
            </label>
            <input
              type="text"
              name="fit_preference"
              value={formData.fit_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Clothing Budget */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Clothing Budget Preference
            </label>
            <select
              name="clothing_budget_preference"
              value={formData.clothing_budget_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select</option>
              <option value="budget">Budget</option>
              <option value="premium">Premium</option>
            </select>
          </div>

          {/* Accessory Preference */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Accessory Preference
            </label>
            <input
              type="text"
              name="accessory_preference"
              value={formData.accessory_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Accessory Budget */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Accessory Budget Preference
            </label>
            <select
              name="accessory_budget_preference"
              value={formData.accessory_budget_preference}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="">Select</option>
              <option value="budget">Budget</option>
              <option value="premium">Premium</option>
            </select>
          </div>

          {/* ✅ NEW FIELDS BELOW */}

          {/* Address */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Address
            </label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="e.g. 2459 Pinewood Dr, Austin, TX 73301"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Address Tag */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Address Type
            </label>
            <input
              type="text"
              name="address_tag"
              value={formData.address_tag}
              onChange={handleChange}
              placeholder="e.g. Apartment, Office, Home"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Payment Detail */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Payment Method
            </label>
            <input
              type="text"
              name="payment_detail"
              value={formData.payment_detail}
              onChange={handleChange}
              placeholder="e.g. PayPal, Credit Card"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Submit Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSaving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-70"
            >
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;